import Vue from 'vue'
import AjaxUtils from '../../util/ajax_utils'
import { MapPanel, DashboardQueryPanel } from '../assets/asset_dashboard'
import VueApexCharts from 'vue-apexcharts'
import {
    CRITICAL,
    HIGH,
    MEDIUM,
    LOW,
    INFO,
    APCK_BLUE,
    APCK_GREEN,
    generateColourRange,
} from '../../util/colour'
import { ApckColumn } from '../../main'
import { getFlagEmoji } from '../../util/iso3166_tools'
import {
    ApckTrustRisksColumn,
    ApckTrustThirdpartyColumn,
    ApckTrustBasicCountColumn

} from './trust_columns'
import DashboardPortlet from './active-checks/DashboardPortlet.vue'
import { ApckTrustScopeEmpty } from './trust_scope_empty'
// Tooltip directive registered globally in globals.js

export const ApckTrustGuage = {
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        src: {
            type: String,
            default: '/trust/score',
        },
        domainId: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            score: 0,
            loading: false,
        }
    },
    methods: {
        refresh: function () {
            let cmp = this
            let url = cmp.src

            // Add domain_id parameter if provided
            if (cmp.domainId) {
                url +=
                    (url.indexOf('?') === -1 ? '?' : '&') +
                    'domain_id=' +
                    encodeURIComponent(cmp.domainId)
            }

            if (cmp.src) {
                cmp.loading = true
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        console.log(data)
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.score = data.score
                            }
                        } else {
                        }
                        cmp.loading = false
                    },
                    fail: function (data) {
                        cmp.loading = false
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false,
                    },
                })
            }
        },
    },
    watch: {
        domainId: function () {
            this.refresh()
        },
    },
    computed: {
        //ToDo: Unify this with below.
        iconLabel: function () {
            let cmp = this
            if (cmp.score === 0) {
                return 'Monitor'
            } else if (cmp.score <= 10) {
                return 'Monitor'
            } else if (cmp.score <= 25) {
                return 'Monitor'
            } else if (cmp.score <= 50) {
                return 'Alert'
            } else if (cmp.score <= 75) {
                return 'Act'
            } else if (cmp.score <= 100) {
                return 'Act'
            }
            return 'Unknown'
        },
        chartSeries: function () {
            let cmp = this
            return [cmp.score]
        },
        chartOptions: function () {
            let cmp = this

            let options = {
                chart: {
                    height: 'auto',
                    type: 'radialBar',
                    offsetY: -10,
                    redrawOnParentResize: false,
                },
                colors: [INFO],
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                fontWeight: 600,
                                fontFamily: 'Inter, Arial, sans-serif',
                                color: '#0F172A',
                                offsetY: 120,
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '30px',
                                fontWeight: 700,
                                fontFamily: 'Inter, Arial, sans-serif',
                                color: '#0F172A',
                                formatter: function (val) {
                                    return val + '%'
                                },
                            },
                        },
                    },
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                        }
                    },
                    active: {
                        filter: {
                            type: 'none',
                        }
                    },
                },
                stroke: {
                    dashArray: 4,
                },
                labels: ['Info Risk'],
            }

            //Modify the score to change the color - matching Python controller scoring
            if (cmp.score === 0) {
                options.colors = [INFO]
                options.labels = ['Monitor Situation']
            } else if (cmp.score <= 10) {
                options.colors = [INFO]
                options.labels = ['Monitor Situation']
            } else if (cmp.score <= 25) {
                options.colors = [LOW]
                options.labels = ['Monitor Situation']
            } else if (cmp.score <= 50) {
                options.colors = [MEDIUM]
                options.labels = ['Vulnerabilities Pending']
            } else if (cmp.score <= 75) {
                options.colors = [HIGH]
                options.labels = ['Action Required']
            } else if (cmp.score <= 100) {
                options.colors = [CRITICAL]
                options.labels = ['Action Required']
            }

            return options
        },
    },
    mounted: function () {
        let cmp = this
        cmp.refresh()
    },
    template: `
        <apck-panel
            class="trust-score-panel"
            title="Risk Score"
            icon="fa-hundred-points"
            no-padding
        >
            <template v-slot:menu>
                <apck-button
                    :handler="refresh"
                    icon="fa-refresh"
                    title="Refresh"
                    class="title-button"
                />
            </template>

            <apexchart
                :options="chartOptions"
                :series="chartSeries"
                type="radialBar"
            />

            <div :class="['trust-score-icon', iconLabel.toLowerCase()]">
                <i v-if="iconLabel === 'Monitor'" class="fa-light fa-monitor-waveform"></i>
                <i v-else-if="iconLabel === 'Alert'" class="fa-regular fa-shield-exclamation"></i>
                <i v-else-if="iconLabel === 'Act'" class="fa-regular fa-triangle-exclamation"></i>
            </div>
            
            <apck-mask :trigger="loading" />
        </apck-panel>
    `,
}

export const ApckTrustCounter = {
    props: {
        title: {
            type: String,
            default: '',
        },
        src: {
            type: String,
            default: '/trust/counts/scope',
            required: true,
        },
        domainId: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: 'light-slate',
        },
        url: {
            type: String,
            default: '',
        }
    },
    data: function () {
        return {
            loading: false,
            count: 0,
        }
    },
    computed: {
        tag() {
            if (this.url) {
                return 'a'
            }

            return 'div'
        }
    },
    methods: {
        refresh: function () {
            let cmp = this
            let url = cmp.src

            // Add domain_id parameter if provided
            if (cmp.domainId) {
                url +=
                    (url.indexOf('?') === -1 ? '?' : '&') +
                    'domain_id=' +
                    encodeURIComponent(cmp.domainId)
            }

            if (cmp.src) {
                cmp.loading = true
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        console.log('counter', data)
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.count = data.count
                            }
                        } else {
                        }
                        cmp.loading = false
                    },
                    fail: function (data) {
                        cmp.loading = false
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false,
                    },
                })
            }
        },
    },
    watch: {
        domainId: function () {
            this.refresh()
        },
    },
    mounted: function () {
        let cmp = this
        cmp.refresh()
    },
    template: `
        <ui-panel-counter
            :title="title"
            :value="count"
            :color="color"
            :loading="loading"
            :tag="tag"
            :url="url"
        />
    `,
}

export const ApckImpactCountColumn = {
    props: {
        risks: {
            type: Object,
            default: function () {
                return {
                    critical: 0,
                    high: 0,
                    medium: 0,
                    low: 0,
                }
            },
        },
    },
    methods: {
        is_active: function (risk) {
            if (risk > 0) {
                return 'active'
            }
        },
    },
    template: `
        <div class="impact-column">
            <span :class="['impact', 'impact-critical', is_active(risks.critical)]">
                {{risks.critical}}
            </span>
            <span :class="['impact', 'impact-high', is_active(risks.high)]">
                {{risks.high}}
            </span>
            <span :class="['impact', 'impact-medium', is_active(risks.medium)]">
                {{risks.medium}}
            </span>
            <span :class="['impact', 'impact-low', is_active(risks.low)]">
                {{risks.low}}
            </span>
        </div>
    `,
}

export const ApckTrustScope = {
    props: {
        src: {
            type: String,
            default: '/trust/scope',
        },
        value: {
            type: String,
            default: '*',
        },
    },
    data: function () {
        return {
            loading: false,
            //Expects an array of objects with key and value {key: 'object_id', value: 'name for select'}
            scope: [],
            selectedScope: this.value,
        }
    },
    methods: {
        refresh: function () {
            let cmp = this
            let url = cmp.src

            if (cmp.src) {
                cmp.loading = true
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        console.log(data)
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.scope = data.data
                            }
                        } else {
                        }
                        cmp.loading = false
                    },
                    fail: function (data) {
                        cmp.loading = false
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false,
                    },
                })
            }
        },
        onScopeChange(value) {
            this.selectedScope = value
            let cmp = this
            cmp.$emit(
                'scope-changed',
                cmp.selectedScope === '*' ? null : cmp.selectedScope
            )
        },
    },
    computed: {
        scopeOptions() {
            return [
                {
                    label: 'Show All Domains',
                    value: '*',
                },
                ...this.scope.map((item) => ({
                    label: item.value,
                    value: item.key,
                })),
            ]
        },
        label() {
            const option = this.scopeOptions.find(
                (opt) => opt.value === this.selectedScope
            )
            return option ? option.label : ''
        },
    },
    watch: {
        value: function (newVal) {
            this.selectedScope = newVal
        },
    },
    mounted: function () {
        let cmp = this
        cmp.refresh()
    },
    template: `
        <ui-dropdown-radio
            name="domainFilter"
            :modelValue="selectedScope"
            :options="scopeOptions"
            :label="label"
            align="right"
            @update:modelValue="onScopeChange"
        />
    `,
}

export const ApckTrustDashboard = {
    components: {
        'apck-trust-counter': ApckTrustCounter,
        'apck-scope-panel': ApckTrustScope,
        'apck-query-panel': DashboardQueryPanel,
        'apck-map-panel': MapPanel,
        'apck-trust-guage': ApckTrustGuage,
        'apck-impact-column': ApckImpactCountColumn,
        'apck-trust-scope-empty': ApckTrustScopeEmpty,
        DashboardPortlet
    },
    props: {
        src: {
            type: String,
            default: '/trust/domain/list/?has_vulns=1&&min_vuln_impact=low',
        },
    },
    data: function () {
        return {
            loading: false,
            selectedDomainId: null,
            hasTrustScope: null, // null = loading, true/false = loaded
            trustScopeCount: 0,
            scanStatus: null,  // null = not loaded, object with { active, status, started_at }
            scanRunning: false,
            scanTriggering: false,
            scanPollTimer: null,
            osintScanningEnabled: false,
            osintScanningLoading: true,
            criticalTooltip: `These are Critcal Risk vulnerabilities as defined by CVSS 3.0, scoring 9.0 and above in that relate to your applications interactions with thirdparty domains and services.`,
            trustScoreTooltip: `**Risk Score Methodology**

The Trust Risk Score (0-100) is calculated using a vulnerability-focused algorithm that evaluates:
* **Trust Relationships (25%, 0-25 points):** Weighted analysis of third-party trust levels, with critical relationships contributing most significantly.
* **Base Vulnerabilities (25%, 0-25 points):** Assessment of identified security vulnerabilities across third-party services, weighted by severity.
* **Critical/High Vulnerability Penalty (50%, 0-50 points):** Substantial additional risk points for critical vulnerabilities (+10 points each) and high vulnerabilities (+5 points each). A single high-severity vulnerability is sufficient to elevate the score into the "Action Required" range, emphasising the importance of timely remediation.
`,
            cols: [
                {
                    data: 'hostname',
                    heading: 'Monitored Domain',
                    canSearch: true,
                    width: 260,
                },
                {
                    data: 'vulns',
                    heading: 'Vulnerabilities',
                    ctype: 'trust-risks',
                    width: 160,
                },
                {
                    data: 'thirdparty_count',
                    heading: 'Third-Parties',
                    ctype: 'trust-count',
                    width: 100,
                    center: true,
                },
                {
                    data: 'last_scanned_at',
                    heading: 'Last Scanned',
                    ctype: 'datecolumn',
                    width: 160,
                },
                /*{
                    data: 'relationships',
                    heading: 'Thirdparty Favicons',
                    ctype: 'trust-thirdparty',
                    minWidth: 180,
                },*/
            ],
            actions: [
                {
                    title: 'View Details',
                    icon: 'fa-eye',
                    class: 'btn-secondary',
                    handler: this.viewDetails,
                    useOwnCol: true,
                    hideLabel: true,
                },
                {
                    title: 'Build Overview Report',
                    icon: 'fa-file-chart-pie',
                    class: 'btn-primary',
                    handler: this.buildReport,
                },
                {
                    title: 'Build Detailed Report (Long)',
                    icon: 'fa-file-chart-column',
                    class: 'btn-primary',
                    handler: this.buildFullReport,
                },
                {
                    title: 'Delete Domain',
                    icon: 'fa-trash',
                    class: 'btn-danger',
                    handler: this.deleteDomain,
                },
            ],
            color: {
                critical: CRITICAL,
                high: HIGH,
                medium: MEDIUM,
                low: LOW,
                info: INFO,
                apck_blue: APCK_BLUE,
                apck_green: APCK_GREEN,
                design_blue: '#2562ec',
            },
        }
    },
    methods: {
        checkTrustScope: function () {
            let cmp = this
            
            AjaxUtils.ajax_get({
                url: '/trust/scope/list?limit=1',
                success: function (data) {
                    if (data && data.success) {
                        cmp.trustScopeCount = data.results || 0
                        cmp.hasTrustScope = cmp.trustScopeCount > 0
                    } else {
                        cmp.hasTrustScope = false
                    }
                },
                fail: function () {
                    cmp.hasTrustScope = false
                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    show_success_flash: false,
                    flash_404_errors: false,
                }
            })
        },
        pollScanStatus: function () {
            let cmp = this

            AjaxUtils.ajax_get({
                url: '/trust/scan/status',
                success: function (data) {
                    if (data && data.success) {
                        cmp.scanStatus = data.data
                        cmp.scanRunning = data.data.active || false
                    }
                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    show_success_flash: false,
                    flash_404_errors: false,
                }
            })
        },
        startScanPoll: function () {
            let cmp = this
            cmp.pollScanStatus()
            if (!cmp.scanPollTimer) {
                cmp.scanPollTimer = setInterval(function () {
                    cmp.pollScanStatus()
                }, 15000)
            }
        },
        stopScanPoll: function () {
            if (this.scanPollTimer) {
                clearInterval(this.scanPollTimer)
                this.scanPollTimer = null
            }
        },
        runScanNow: function () {
            let cmp = this
            cmp.scanTriggering = true

            AjaxUtils.ajax_get({
                url: '/trust/scan/run-now',
                success: function (data) {
                    cmp.scanTriggering = false
                    if (data && data.success) {
                        cmp.scanRunning = true
                        cmp.pollScanStatus()
                    }
                },
                fail: function () {
                    cmp.scanTriggering = false
                },
                opts: {
                    dataType: 'json',
                }
            })
        },
        loadOsintScanningSetting: function () {
            var cmp = this;
            cmp.osintScanningLoading = true;
            AjaxUtils.ajax_get({
                url: '/trust/settings/view',
                success: function(data) {
                    cmp.osintScanningLoading = false;
                    if (data.success && data.data) {
                        cmp.osintScanningEnabled = !!data.data.enable_osint_scanning;
                    }
                },
                fail: function() {
                    cmp.osintScanningLoading = false;
                },
                opts: { dataType: 'json', flash_form_errors: false, flash_404_errors: false, show_success_flash: false }
            });
        },
        toggleOsintScanning: function (value) {
            var cmp = this;
            cmp.osintScanningLoading = true;
            AjaxUtils.ajax_post({
                url: '/trust/settings/update',
                data: JSON.stringify({ enable_osint_scanning: value }),
                success: function(data) {
                    cmp.osintScanningLoading = false;
                    if (data.success) {
                        cmp.osintScanningEnabled = value;
                        cmp.$flash({ message: 'OSINT Scanning ' + (value ? 'enabled' : 'disabled'), type: 'success' });
                        if (value) {
                            cmp.startScanPoll();
                        }
                    } else {
                        cmp.$flash({ message: data.message, type: 'error' });
                    }
                },
                fail: function() {
                    cmp.osintScanningLoading = false;
                    cmp.$flash({ message: 'Failed to update OSINT Scanning setting', type: 'error' });
                },
                opts: { dataType: 'json', contentType: 'application/json', flash_form_errors: false, flash_404_errors: false }
            });
        },
        goToScans: function () {
            window.location.href = '/trust/scans'
        },
        goToScopeManagement: function () {
            window.location.href = '/trust/scope/manage?openModal=true'
        },
        downloadExecReport: function () {
            let cmp = this

            // Show loading mask
            cmp.loading = true

            // Build query parameters
            let params = {
                format: 'pdf'
            }

            // Add domain_id filter if active
            if (cmp.selectedDomainId) {
                params.domain_id = cmp.selectedDomainId
            }

            let queryString = Object.keys(params)
                .map(
                    (key) =>
                        encodeURIComponent(key) +
                        '=' +
                        encodeURIComponent(params[key])
                )
                .join('&')

            let url = '/trust/reporting/executive-summary?' + queryString

            // Use fetch API for better download handling
            fetch(url, {
                credentials: 'same-origin',
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok')
                    }

                    // Get the filename from the Content-Disposition header if available
                    let filename = 'trust_executive_summary.pdf'

                    const contentDisposition = response.headers.get(
                        'Content-Disposition'
                    )

                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(
                            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                        )

                        if (filenameMatch && filenameMatch[1]) {
                            // Remove quotes if present
                            filename = filenameMatch[1].replace(/['"]/g, '')
                        }
                    }

                    return response.blob().then((blob) => ({ blob, filename }))
                })
                .then(({ blob, filename }) => {
                    // Create a URL for the blob and trigger download
                    const downloadUrl = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')

                    link.href = downloadUrl
                    link.download = filename

                    document.body.appendChild(link)
                    link.click()

                    // Clean up
                    window.URL.revokeObjectURL(downloadUrl)
                    document.body.removeChild(link)

                    cmp.loading = false
                })
                .catch((error) => {
                    console.error('Error downloading executive report:', error)
                    cmp.loading = false

                    // Fallback to direct URL navigation
                    console.log('Falling back to direct URL navigation')
                    window.location.href = url
                })
        },
        buildReport: function (rec) {
            let cmp = this
            let hostname = rec.get('hostname')
            console.log('Build report for:', hostname)

            // Directly generate PDF report for the selected domain scope
            cmp.generatePdfReport(hostname, '0')
        },
        buildFullReport: function (rec) {
            let cmp = this
            let hostname = rec.get('hostname')
            console.log('Build report for:', hostname)

            // Directly generate PDF report for the selected domain scope
            cmp.generatePdfReport(hostname, '1')
        },
        generatePdfReport: function (hostname, full) {
            let cmp = this

            // Show loading mask
            cmp.loading = true

            // Build query parameters for the selected domain
            let params = {
                domain: hostname,
                full: full
            }

            // Add current domain filter if active
            if (cmp.selectedDomainId) {
                params.domain_id = cmp.selectedDomainId
            }

            let queryString = Object.keys(params)
                .map(
                    (key) =>
                        encodeURIComponent(key) +
                        '=' +
                        encodeURIComponent(params[key])
                )
                .join('&')

            let url = '/trust/export/pdf?' + queryString

            // Use fetch API for better download handling (cookies will be sent automatically)
            fetch(url, {
                credentials: 'same-origin', // Ensure cookies are sent
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok')
                    }

                    // Get the filename from the Content-Disposition header if available
                    let filename = `trust-report-${hostname}.pdf`

                    const contentDisposition = response.headers.get(
                        'Content-Disposition'
                    )

                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(
                            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                        )

                        if (filenameMatch && filenameMatch[1]) {
                            // Remove quotes if present
                            filename = filenameMatch[1].replace(/['"]/g, '')
                        }
                    }

                    return response.blob().then((blob) => ({ blob, filename }))
                })
                .then(({ blob, filename }) => {
                    // Create a URL for the blob and trigger download
                    const downloadUrl = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')

                    link.href = downloadUrl
                    link.download = filename // Use the server-provided filename

                    document.body.appendChild(link)
                    link.click()

                    // Clean up
                    window.URL.revokeObjectURL(downloadUrl)
                    document.body.removeChild(link)

                    cmp.loading = false
                })
                .catch((error) => {
                    console.error('Error downloading using fetch:', error)
                    cmp.loading = false

                    // Fallback to direct URL navigation
                    console.log('Falling back to direct URL navigation')
                    window.location.href = url
                })
        },
        viewDetails: function (rec) {
            let domain_id = encodeURIComponent(rec.get('_id'))
            window.location.href = `/trust/domain/${domain_id}/view`
        },
        deleteDomain: function (rec) {
            let cmp = this
            let hostname = rec.get('hostname')
            let domain_id = rec.get('_id')

            window.app.confirm(
                `Are you sure you want to delete domain '${hostname}' and all associated relationships, vulnerabilities, and discovered trusts?`,
                'Delete Domain',
                function() {
                    cmp.loading = true

                    AjaxUtils.ajax_get({
                        url: '/trust/domain/delete?domain_id=' + encodeURIComponent(domain_id),
                        success: function(data) {
                            cmp.loading = false
                            if (data && data.success) {
                                // Reload the table
                                if (cmp.$refs.trustTable && cmp.$refs.trustTable.store) {
                                    cmp.$refs.trustTable.store.reload()
                                }
                            }
                        },
                        fail: function(data) {
                            cmp.loading = false
                        },
                        opts: {
                            dataType: 'json',
                        }
                    })
                }
            )
        },
        onScopeChanged: function (domainId) {
            let cmp = this
            cmp.selectedDomainId = domainId
        },
        buildUrlWithDomainId: function (baseUrl) {
            let cmp = this

            if (cmp.selectedDomainId) {
                return (
                    baseUrl +
                    (baseUrl.indexOf('?') === -1 ? '?' : '&') +
                    'domain_id=' +
                    encodeURIComponent(cmp.selectedDomainId)
                )
            }

            return baseUrl
        },
        buildSrc: function () {
            return this.buildUrlWithDomainId(this.src)
        },
        tableRowAction(row) {
            this.viewDetails(row)
        }
    },
    computed: {
        tableSrc: function () {
            return this.buildSrc()
        },
    },
    watch: {
        selectedDomainId: function () {
            // Force table refresh when domain changes
            if (this.$refs.trustTable) {
                this.$refs.trustTable.$data.store.refresh()
            }
        },
    },
    created: function () {
        // Register custom column components globally for this instance
        Vue.component('apck-trust-risks', ApckTrustRisksColumn)
        Vue.component('apck-trust-thirdparty', ApckTrustThirdpartyColumn)
        Vue.component('apck-trust-count', ApckTrustBasicCountColumn)
    },
    mounted: function () {
        this.checkTrustScope()
        this.loadOsintScanningSetting()
        this.startScanPoll()
    },
    beforeUnmount: function () {
        this.stopScanPoll()
    },
    template: `
        <div class="new-ui">
            <!-- Empty state when no Trust Scope configured -->
            <template v-if="hasTrustScope === false">
                <div class="page-title-bar--sticky">
                    <ui-page-title-bar title="Trust Monitor Dashboard" />
                </div>
                <apck-trust-scope-empty
                    title="Welcome to Trust Monitor"
                    buttonLabel="Configure Trust Scope"
                    @action="goToScopeManagement"
                />
            </template>
            
            <!-- Loading state -->
            <template v-else-if="hasTrustScope === null">
                <div class="page-title-bar--sticky">
                    <ui-page-title-bar title="Trust Monitor Dashboard" />
                </div>
                <ui-layout align="center" justify="center" class="py-16">
                    <ui-spinner show theme="dark" />
                </ui-layout>
            </template>
            
            <!-- Normal dashboard when Trust Scope exists -->
            <template v-else>
            <div class="page-title-bar--sticky">
                <ui-page-title-bar title="Trust Monitor Dashboard">
                    <template v-if="!osintScanningEnabled">
                        <ui-split-button
                            :label="'OSINT Scanning Disabled'"
                            iconLeft="fa-circle-xmark"
                            type="outline"
                            :disabled="osintScanningLoading"
                            secondaryLabel="Scan Settings"
                            secondaryIcon="fa-cog"
                            secondaryUrl="/trust/settings?tab=scan"
                            @click="toggleOsintScanning(true)"
                        />
                    </template>
                    <template v-else>
                        <ui-split-button
                            v-if="scanRunning"
                            label="Scan Running"
                            iconLeft="fa-spinner fa-spin"
                            type="outline"
                            color="green"
                            secondaryLabel="Scan Settings"
                            secondaryIcon="fa-cog"
                            secondaryUrl="/trust/settings?tab=scan"
                            @click="goToScans"
                        />
                        <ui-split-button
                            v-else
                            label="Run Scan Now"
                            iconLeft="fa-play"
                            type="outline"
                            :disabled="scanTriggering"
                            secondaryLabel="Scan Settings"
                            secondaryIcon="fa-cog"
                            secondaryUrl="/trust/settings?tab=scan"
                            @click="runScanNow"
                        />
                    </template>
                    <ui-button
                        label="Executive Summary Report"
                        iconLeft="fa-download"
                        type="outline"
                        @click.prevent="downloadExecReport"
                    />
                    <apck-scope-panel @scope-changed="onScopeChanged" />
                </ui-page-title-bar>
            </div>
            <ui-layout type="grid" cols="9" class="apck-trust-dashboard">
                <div class="portlet col col-span-9">
                    <apck-query-panel
                        class="vuln-counter-panel"
                        view="list"
                        :src="buildUrlWithDomainId('/trust/vulns/top')"
                        search="trust/vulnerabilities?status=unfixed"
                        query="impact_levels"
                        :build-query="true"
                        :colors="[color.critical, color.high, color.medium, color.low, color.info]"
                        :legend="false"
                        :key="'risks-' + selectedDomainId"
                        useNewListStyle
                        newListStyleCols="6"
                        newListStyleGap="4"
                        newListStylePanelType="counter"
                        tooltip-position="right"
                    />
                </div>
                
                <div class="portlet col col-span-3 row-span-4">
                    <apck-trust-guage
                        src="/trust/score"
                        :domain-id="selectedDomainId"
                        v-tooltip:right="trustScoreTooltip"
                    />
                </div>

                <div class="portlet col col-span-4 row-span-4">
                    <apck-map-panel
                        class="trust-map-panel"
                        title="Third-Parties by Country"
                        icon="fa-map-o"
                        name="Trusts"
                        :src="buildUrlWithDomainId('/trust/countries/map')"
                        :key="'map-' + selectedDomainId"
                        :color-steps="2"
                        search="trust/relationships"
                        query="country"
                        :build-query="true"
                    />
                </div>

                <div class="portlet col col-span-2 row-span-4">
                    <apck-query-panel
                        class="map-counter-panel"
                        :views="['donut', 'list']"
                        view="list"
                        :src="buildUrlWithDomainId('/trust/countries/top')"
                        search="trust/relationships"
                        query="country"
                        :build-query="true"
                        title="Top Countries"
                        icon="fa-map"
                        :chart-height="280"
                        :legend="false"
                        :key="'countries-' + selectedDomainId"
                        useNewListStyle
                    />
                </div>

                <div class="portlet col col-span-3 row-span-4 col-start-1">
                    <apck-query-panel
                        class="risk-counter-panel"
                        :views="['donut', 'list']"
                        view="list"
                        :src="buildUrlWithDomainId('/trust/risk/top')"
                        search="trust/relationships"
                        query="risk_level"
                        :build-query="true"
                        title="Third-Parties by Trust"
                        icon="fa-triangle-exclamation"
                        :colors="[color.critical, color.high, color.medium, color.low, color.info]"
                        :legend="false"
                        :key="'risks-' + selectedDomainId"
                        tooltip-position="right"
                        useNewListStyle
                    />
                </div>

                <div class="portlet col col-span-2">
                    <dashboard-portlet
                        v-if="$permissions.enable_active_checks"
                        class="h-full"
                    />
                    
                    <apck-trust-counter
                        v-else
                        src="/trust/counts/trusts"
                        title="Trusted Relationships"
                        :domain-id="selectedDomainId"
                        url="/trust/relationships"
                        v-tooltip="'How many relationships you have between your domains (applications) and your third-parties'"
                    />
                </div>

                <div class="portlet col col-span-2">
                    <apck-trust-counter
                        src="/trust/counts/scope"
                        title="Domains Monitored"
                        :domain-id="selectedDomainId"
                        color="blue"
                        url="/trust/domain"
                        v-tooltip="'How many domains (applications) are currently covered by Trust Monitor'"
                        class="h-full"
                    />
                </div>

                <div class="portlet col col-span-2">
                    <apck-trust-counter
                        src="/trust/counts/vulnerabilities"
                        title="Vulnerabilities"
                        :domain-id="selectedDomainId"
                        color="red"
                        url="/trust/vulnerabilities"
                        v-tooltip="'How many third-party relationships have vulnerabilities that affect your domains (applications)'"
                        class="h-full"
                    />
                </div>

                <div class="portlet col col-span-3 row-span-3">
                    <apck-query-panel
                        class="scope-counter-panel"
                        :views="['bar','donut']"
                        view="bar"
                        :src="buildUrlWithDomainId('/trust/scope/top')"
                        search="/trust/domain/query"
                        query="domain"
                        :build-query="true"
                        title="Most Third-Parties"
                        icon="fa-bullseye"
                        :chart-height="280"
                        :legend="false"
                        :colors="[]"
                        :color-start="color.design_blue"
                        :color-steps="5"
                        :key="'scopes-' + selectedDomainId"
                    />
                </div>

                <div class="portlet col col-span-3 row-span-3">
                    <apck-query-panel
                        class="thirdparty-counter-panel"
                        :views="['treemap','donut']"
                        view="treemap"
                        :src="buildUrlWithDomainId('/trust/thirdparties/top')"
                        search="trust/relationships"
                        query="thirdparty"
                        :build-query="true"
                        title="Common Third-Parties"
                        icon="fa-code"
                        :chart-height="280"
                        :legend="false"
                        :colors="[]"
                        :colorStart="color.design_blue"
                        :color-steps="3"
                        :key="'thirdparties-' + selectedDomainId"
                    />
                </div>
      
                <div class="portlet col col-span-9 row-span-3">
                    <apck-panel
                        title="Vulnerable Domains Summary"
                        icon="fa-chart-line"
                        no-padding
                        class="trust-data-panel"
                    >
                        <apck-table
                            ref="trustTable"
                            class="panel"
                            :columns="cols"
                            :src="tableSrc"
                            :actions="actions"
                            :limit="50"
                            :key="'trust-table-' + selectedDomainId"
                            :showToolbar="false"
                            :showPageBar="false"
                            :sglRowAction="tableRowAction"
                            newStyleTable
                        />
                    </apck-panel>
                </div>
            </ui-layout>
            </template>
        </div>
    `,
}
